import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL;
const API = `${API_BASE_URL}/api/user` ;

function Cards() {

    const token = localStorage.getItem("token");

    const [cards, setCards] = useState([]);

    const [showModal, setShowModal] = useState(false);

    const [editingCard, setEditingCard] = useState(null);

    const emptyCard = {

        holderName: "",

        brand: "Visa",

        last4: "",

        expiry: "",

        isDefault: false

    };

    const [form, setForm] = useState(emptyCard);

    useEffect(() => {

        loadCards();

    }, []);

    const loadCards = async () => {

        try {

            const res = await axios.get(

                `${API}/profile`,

                {

                    headers: {

                        Authorization: `Bearer ${token}`

                    }

                }

            );

            setCards(res.data.cards || []);

        }

        catch (err) {

            console.log(err);

        }

    };

    const handleChange = (e) => {

        const { name, value, checked, type } = e.target;

        setForm({

            ...form,

            [name]: type === "checkbox" ? checked : value

        });

    };

    const openAdd = () => {

        setEditingCard(null);

        setForm(emptyCard);

        setShowModal(true);

    };

    const openEdit = (card) => {

        setEditingCard(card);

        setForm(card);

        setShowModal(true);

    };

    const saveCard = async () => {

        try {

            if (editingCard) {

                await axios.put(

                    `${API}/card/${editingCard._id}`,

                    form,

                    {

                        headers: {

                            Authorization: `Bearer ${token}`

                        }

                    }

                );

            }

            else {

                await axios.post(

                    `${API}/card`,

                    form,

                    {

                        headers: {

                            Authorization: `Bearer ${token}`

                        }

                    }

                );

            }

            setShowModal(false);

            loadCards();

        }

        catch (err) {

            console.log(err);

            alert("Unable to save payment method.");

        }

    };

    const deleteCard = async (id) => {

        if (!window.confirm("Delete this payment method?")) {

            return;

        }

        try {

            await axios.delete(

                `${API}/card/${id}`,

                {

                    headers: {

                        Authorization: `Bearer ${token}`

                    }

                }

            );

            loadCards();

        }

        catch (err) {

            console.log(err);

        }

    };

    return (

        <div className="profile-card">

            <div className="card-title">

                <h2>

                    Saved Payment Methods

                </h2>

                <button

                    className="theme-btn"

                    onClick={openAdd}

                >

                    + Add Card

                </button>

            </div>

            <div className="cards-grid">

                {

                    cards.length === 0 &&

                    <div className="empty-box">

                        <h3>

                            No Payment Methods

                        </h3>

                        <p>

                            Save a payment method for faster checkout.

                        </p>

                    </div>

                }

                {

                    cards.map((card) => (

                        <div

                            className="bank-card"

                            key={card._id}

                        >

                            {

                                card.isDefault &&

                                <span className="badge">

                                    Default

                                </span>

                            }

                            <h3>

                                {card.brand}

                            </h3>

                            <div className="card-number">

                                **** **** **** {card.last4}

                            </div>

                            <div className="card-footer">

                                <div>

                                    <h4>

                                        {card.holderName}

                                    </h4>

                                </div>

                                <span>

                                    {card.expiry}

                                </span>

                            </div>

                            <div

                                className="address-actions"

                                style={{marginTop:"20px"}}

                            >

                                <button

                                    className="edit-btn"

                                    onClick={() => openEdit(card)}

                                >

                                    Edit

                                </button>

                                <button

                                    className="delete-btn"

                                    onClick={() => deleteCard(card._id)}

                                >

                                    Delete

                                </button>

                            </div>

                        </div>

                    ))

                }

            </div>

            {

                showModal &&

                <div className="modal">

                    <div className="modal-content">

                        <h2>

                            {

                                editingCard ?

                                "Edit Payment Method"

                                :

                                "Add Payment Method"

                            }

                        </h2>

                        <input

                            name="holderName"

                            placeholder="Card Holder Name"

                            value={form.holderName}

                            onChange={handleChange}

                        />

                        <select

                            name="brand"

                            value={form.brand}

                            onChange={handleChange}

                        >

                            <option>

                                Visa

                            </option>

                            <option>

                                Mastercard

                            </option>

                            <option>

                                RuPay

                            </option>

                            <option>

                                American Express

                            </option>

                        </select>

                        <input

                            name="last4"

                            maxLength={4}

                            placeholder="Last 4 Digits"

                            value={form.last4}

                            onChange={handleChange}

                        />

                        <input

                            name="expiry"

                            placeholder="MM/YY"

                            value={form.expiry}

                            onChange={handleChange}

                        />

                        <label

                            style={{

                                display:"flex",

                                gap:"10px",

                                marginTop:"15px"

                            }}

                        >

                            <input

                                type="checkbox"

                                name="isDefault"

                                checked={form.isDefault}

                                onChange={handleChange}

                            />

                            Set as Default

                        </label>

                        <div className="modal-buttons">

                            <button

                                className="theme-btn"

                                onClick={saveCard}

                            >

                                Save

                            </button>

                            <button

                                className="outline-btn"

                                onClick={() => setShowModal(false)}

                            >

                                Cancel

                            </button>

                        </div>

                    </div>

                </div>

            }

        </div>

    );

}

export default Cards;